var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.388 5.82261C15.3232 6.00472 16.1827 6.46123 16.8565 7.1337C17.5302 7.80617 17.9876 8.66402 18.1701 9.59743M14.388 2C16.331 2.21544 18.1429 3.08388 19.5261 4.46272C20.9093 5.84157 21.7817 7.64887 22 9.58788M21.0425 17.214V20.0809C21.0436 20.3471 20.989 20.6105 20.8821 20.8544C20.7753 21.0983 20.6186 21.3172 20.4221 21.4971C20.2256 21.677 19.9937 21.814 19.7411 21.8993C19.4885 21.9845 19.2208 22.0162 18.9552 21.9922C16.0089 21.6727 13.1787 20.6678 10.6921 19.0584C8.37869 17.5911 6.4173 15.6335 4.94724 13.3245C3.32908 10.8314 2.32206 7.99289 2.00777 5.03897C1.98384 4.7747 2.01531 4.50836 2.10017 4.25689C2.18503 4.00543 2.32141 3.77435 2.50065 3.57838C2.67989 3.3824 2.89804 3.22582 3.14123 3.11861C3.38442 3.0114 3.64731 2.9559 3.91316 2.95565H6.78561C7.25028 2.95109 7.70076 3.11532 8.05309 3.41774C8.40541 3.72016 8.63554 4.14013 8.70057 4.59937C8.82181 5.51686 9.04665 6.41772 9.37081 7.28476C9.49963 7.62681 9.52751 7.99855 9.45115 8.35593C9.37478 8.71331 9.19737 9.04135 8.93994 9.30118L7.72394 10.5149C9.08697 12.9074 11.0717 14.8883 13.4688 16.2488L14.6848 15.0351C14.9452 14.7782 15.2738 14.6011 15.6319 14.5249C15.99 14.4486 16.3624 14.4765 16.7051 14.6051C17.5738 14.9286 18.4764 15.153 19.3956 15.274C19.8608 15.3395 20.2855 15.5733 20.5892 15.931C20.8928 16.2887 21.0542 16.7453 21.0425 17.214Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.e6152cdefd7984ed9fbb33cf0ddae9d9.svg";
export { ForwardRef as ReactComponent };